class QuickLinksScroller extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.quick-links__list');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (!this.list || !this.prevButton || !this.nextButton) return;

    this.update = this.update.bind(this);
    this.list.addEventListener('scroll', this.update, { passive: true });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.list);
    this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
    this.nextButton.addEventListener('click', () => this.scrollByPage(1));
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.list?.removeEventListener('scroll', this.update);
  }

  scrollByPage(direction) {
    this.list.scrollBy({ left: direction * this.list.clientWidth * 0.75, behavior: 'smooth' });
  }

  update() {
    const maxScroll = this.list.scrollWidth - this.list.clientWidth;
    this.prevButton.hidden = this.list.scrollLeft <= 1;
    this.nextButton.hidden = this.list.scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get('quick-links-scroller')) {
  customElements.define('quick-links-scroller', QuickLinksScroller);
}
